import { z } from 'zod'

/** Who the person is in the back office: the service owners from ADMIN_USERS or support staff added in the UI. */
export const accessLevelSchema = z.enum(['owner', 'support'])

/** Sections of the back office; the server checks them on every API call, the UI hides what is not allowed. */
export const sectionSchema = z.enum([
  'overview',
  'updates',
  'support',
  'support-live',
  'salons',
  'referrals',
  'promo-codes',
  'staff',
])

export type AccessLevel = z.infer<typeof accessLevelSchema>
export type Section = z.infer<typeof sectionSchema>

export const ACCESS_SECTIONS: Record<AccessLevel, readonly Section[]> = {
  owner: sectionSchema.options,
  // Support works with clients: no revenue metrics, no referral payouts, no say over who gets access.
  // Support runs promo codes too: hands them out to salons and fixes limits when a code does not work.
  support: ['support-live', 'support', 'salons', 'updates', 'promo-codes'],
}

export const ACCESS_LABELS: Record<AccessLevel, string> = {
  owner: 'Владелец сервиса',
  support: 'Поддержка',
}

export const canAccess = (access: AccessLevel, section: Section): boolean => ACCESS_SECTIONS[access].includes(section)

/** Giving a paid plan away is a money decision: only the service owners make it. */
export const canGrantPlans = (access: AccessLevel): boolean => access === 'owner'

/** Owners and support create and change promo codes; who did it goes to the platform as the actor. */
export const canManagePromoCodes = (access: AccessLevel): boolean => access === 'owner' || access === 'support'
